"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var compare_uncertainty_chart_1 = require("../compare-uncertainty2/compare-uncertainty.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var ExecutiveDashboardComponent = /** @class */ (function (_super) {
    __extends(ExecutiveDashboardComponent, _super);
    function ExecutiveDashboardComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'ExecutiveDashboard') || this;
        var ctrl = _this;
        $scope.$on('command:EXECUTIVE_DASHBOARD', function (event, args) {
            ctrl.opportunityRiskMix = args.config.data.data[0].opportunityRiskMix;
            ctrl.nodeNames = args.config.data.data[0].sortedLeafNodeNames;
            ctrl.initComponent(event, args);
            ctrl.drawReadinessChart();
            ctrl.tableData = args.config.data.data[0].tableData;
            ctrl.menu = [];
        });
        return _this;
    }
    ExecutiveDashboardComponent.prototype.getChartOptions = function (graph, options) {
        options['chartInverted'] = true;
        options['chartTitle'] = 'Combined Uncertainty';
        options['legendsEnabled'] = false;
        return compare_uncertainty_chart_1.getChartOptions(graph, options);
    };
    ExecutiveDashboardComponent.prototype.drawReadinessChart = function () {
        var ctrl = this;
        var totalBars = ctrl.opportunityRiskMix[0].data.length;
        ctrl.chartHeight = compare_uncertainty_chart_1.getChartHeight(totalBars) + 70;
        Highcharts.chart('readinessChartContainer', {
            chart: {
                type: 'column',
                zoomType: 'xy',
                inverted: true,
                width: 200,
                height: ctrl.chartHeight,
                marginTop: 70
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Readiness Mix'
            },
            xAxis: {
                labels: {
                    enabled: false
                },
                categories: ctrl.nodeNames
            },
            yAxis: {
                min: 0,
                max: 100,
                title: {
                    text: ''
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: ( // theme
                        Highcharts.defaultOptions.title.style &&
                            Highcharts.defaultOptions.title.style.color) || 'gray'
                    }
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '{series.name}: {point.y}%<br/>Total: {point.stackTotal}%',
                crosshairs: true
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false
                    },
                    borderWidth: 0
                }
            },
            series: ctrl.opportunityRiskMix
        });
    };
    ExecutiveDashboardComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                smartorg: '=',
                menu: '='
            },
            template: require("./executive-dashboard.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], ExecutiveDashboardComponent);
    return ExecutiveDashboardComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.ExecutiveDashboardComponent = ExecutiveDashboardComponent;
angular.module('smartorg.r6.acts.executiveDashboard', []).component('executiveDashboard', ExecutiveDashboardComponent);
module.exports = 'smartorg.r6.acts.executiveDashboard';
//# sourceMappingURL=executive-dashboard.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/executive-dashboard/executive-dashboard.component.js